import { CheckCircle, Clock, Users, Zap } from "lucide-react";
import { useEffect, useState } from "react";
const ProcessTimeline = () => {
  const [visibleSteps, setVisibleSteps] = useState<number[]>([]);
  useEffect(() => {
    const timer = setInterval(() => {
      setVisibleSteps(prev => {
        if (prev.length < 4) {
          return [...prev, prev.length];
        }
        return prev;
      });
    }, 500);
    return () => clearInterval(timer);
  }, []);
  const steps = [{
    weeks: "Weeks 1–2",
    title: "Discovery & Strategy",
    description: "Audit, audience, pillars, team plan, KPI baseline",
    icon: Clock,
    color: "text-primary",
    bgColor: "bg-primary/20"
  }, {
    weeks: "Weeks 3–6",
    title: "Team Building",
    description: "Talent sourcing, trials, onboarding, environment + tools",
    icon: Users,
    color: "text-accent",
    bgColor: "bg-accent/20"
  }, {
    weeks: "Weeks 7–10",
    title: "Training & Handover",
    description: "SOPs, templates, quality gates, founder 90-minute week",
    icon: Zap,
    color: "text-primary",
    bgColor: "bg-primary/20"
  }, {
    weeks: "Months 3–6",
    title: "Optimization",
    description: "Dashboards, cadence tuning, coaching, and independence verification",
    icon: CheckCircle,
    color: "text-accent",
    bgColor: "bg-accent/20"
  }];
  return <section id="timeline" className="py-24 bg-gradient-to-b from-background to-background/80">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Your 90-Day Journey to Content Independence
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            From audit to full autonomy in just 12 weeks
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => {
            const Icon = step.icon;
            const isVisible = visibleSteps.includes(index);
            return <div key={index} className={`relative transition-all duration-500 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                  <div className="bg-card border rounded-lg p-6 h-full hover:shadow-lg transition-shadow">
                    <div className={`w-12 h-12 rounded-full ${step.bgColor} flex items-center justify-center mb-4`}>
                      <Icon className={`h-6 w-6 ${step.color}`} />
                    </div>
                    
                    <div className="text-sm font-medium text-primary mb-2">
                      {step.weeks}
                    </div>
                    
                    <h3 className="font-semibold text-lg mb-3">
                      {step.title}
                    </h3>
                    
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                  
                  {index < steps.length - 1 && <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                      
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
};
export default ProcessTimeline;